export default __webpack_public_path__ + "static/media/sheet.09978ffd.png";